import React from 'react';

import AmberTickIcon from 'icons/status-ic-amber.svg';
import GreenTickIcon from 'icons/status-ic-green.svg';
import GreyTickIcon from 'icons/status-ic-grey-tick.svg';
import RedCrossIcon from 'icons/status-ic-red.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function TrainingRecordsTabStatus({ trainingStatus }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'mobileTrainingProfile.components.homeScreen.TrainingRecordsTabStatus',
  });

  const { t: i18nTTraining } = useTranslation('common', {
    keyPrefix: 'training',
  });

  switch (trainingStatus) {
    case 'noRequirements':
      return (
        <div className='tw-flex tw-items-center'>
          <GreyTickIcon
            className='tw-flex-none [&_rect]:tw-fill-grey-300'
            height={32}
            width={32}
          />
          <span className='tw-ml-3 tw-mr-3'>
            {i18nTTraining('dontHaveAnyRequiredTraining')}
          </span>
        </div>
      );
    case 'expiring':
      return (
        <div className='tw-flex tw-items-center'>
          <AmberTickIcon
            className='tw-flex-none [&_rect]:tw-fill-amber-400'
            height={32}
            width={32}
          />
          <span className='tw-ml-3 tw-mr-3'>{i18nT('expiring')}</span>
        </div>
      );
    case 'invalid':
      return (
        <div className='tw-flex tw-items-center'>
          <RedCrossIcon
            className='tw-flex-none [&_rect]:tw-fill-red-500'
            height={32}
            width={32}
          />
          <span className='tw-ml-3 tw-mr-3'>{i18nT('invalid')}</span>
        </div>
      );
    case 'valid':
      return (
        <div className='tw-flex tw-items-center'>
          <GreenTickIcon
            className='tw-flex-none [&_rect]:tw-fill-green-400'
            height={32}
            width={32}
          />
          <span className='tw-ml-3 tw-mr-3'>{i18nT('valid')}</span>
        </div>
      );
  }
}

TrainingRecordsTabStatus.propTypes = {
  trainingStatus: PropTypes.string.isRequired,
};
